import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'src/constants'
import { productService } from 'src/services'

export const useProductConsumerScansInfo = (productId: string) => {
  return useQuery(
    [QUERY_KEYS.GET_PRODUCT_CONSUMER_SCANS_INFO, productId],
    () => productService.getProductConsumerScansInfo(productId),
    { enabled: !!productId },
  )
}
